import React from "react";
import { Row, Col, ProgressBar } from "react-bootstrap";
import { Container } from "reactstrap";

export default class Skills extends React.Component {
    constructor() {
        super();
        this.state = {
            skills: [
                {
                    name: "HTML5/CSS3",
                    percent: 85
                }, {
                    name: "JAVASCRIPT",
                    percent: 79
                },
                {
                    name: "REACTJS",
                    percent: 92
                },
                {
                    name: "NODE.JS",
                    percent: 75
                },
                {
                    name: "React Native",
                    percent: 55
                },
                {
                    name: "Python",
                    percent: 40
                }
            ]
        };
    }
    render() {
        return (
            <div style={styles.skillsContainer} className="skillsContainer">
                <Container>
                    <Row>
                        <Col md={6} style={window.innerWidth>=500?{marginTop: 200}:{}}>
                            <h1 style={styles.stylesRepresentationHeading}>my skills</h1>
                            <br />
                            <p style={styles.stylesRepresentationPara}>Here are all my skills which I've learned!</p>
                        </Col>
                        <Col md={6} style={styles.progressBarContainer}>
                            {
                                this.state.skills.map((skill, i) => <div style={styles.progressBar} key={i}><h3 style={styles.progressBarName}>{skill.name}</h3><ProgressBar now={skill.percent} label={`${skill.percent}%`} /></div>)
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const styles = {
    skillsContainer: {
        height: 700,
        backgroundColor: "#0C0A09",
        fontFamily: "Roboto, sans-serif",
        paddingTop: 70
    },
    stylesRepresentationHeading: {
        fontSize: 30,
        color: "#f1f1f1",
        fontWeight: 700,
        textTransform: "uppercase"
    },
    stylesRepresentationPara: {
        color: "#929292",
        fontSize: 16,
        lineHeight: "30px"
    },
    progressBarContainer: {
    },
    progressBar: {
        marginBottom: 40
    },
    progressBarName: {
        fontSize: 16,
        color: "#566366",
        fontWeight: 600
    }
};


// WEBPACK FOOTER //
// ./src/Components/skills.jsx